export interface State {
  id: string;
  name: string;
  slug: string;
  abbreviation: string;
  has_lottery: boolean;
  official_lottery_url?: string | null;
}

export const STATES: State[] = [
  ["AL", "Alabama", false, null],
  ["AK", "Alaska", false, null],
  ["AZ", "Arizona", true, "https://www.arizonalottery.com"],
  ["AR", "Arkansas", true, "https://www.myarkansaslottery.com"],
  ["CA", "California", true, "https://www.calottery.com"],
  ["CO", "Colorado", true, "https://www.coloradolottery.com"],
  ["CT", "Connecticut", true, "https://www.ctlottery.org"],
  ["DE", "Delaware", true, "https://www.delottery.com"],
  ["DC", "District of Columbia", true, "https://dclottery.com"],
  ["FL", "Florida", true, "https://www.flalottery.com"],
  ["GA", "Georgia", true, "https://www.galottery.com"],
  ["HI", "Hawaii", false, null],
  ["ID", "Idaho", true, "https://www.idaholottery.com"],
  ["IL", "Illinois", true, "https://www.illinoislottery.com"],
  ["IN", "Indiana", true, "https://hoosierlottery.com"],
  ["IA", "Iowa", true, "https://ialottery.com"],
  ["KS", "Kansas", true, "https://www.kslottery.com"],
  ["KY", "Kentucky", true, "https://www.kylottery.com"],
  ["LA", "Louisiana", true, "https://louisianalottery.com"],
  ["ME", "Maine", true, "https://www.mainelottery.com"],
  ["MD", "Maryland", true, "https://www.mdlottery.com"],
  ["MA", "Massachusetts", true, "https://www.masslottery.com"],
  ["MI", "Michigan", true, "https://www.michiganlottery.com"],
  ["MN", "Minnesota", true, "https://www.mnlottery.com"],
  ["MS", "Mississippi", true, "https://mslottery.com"],
  ["MO", "Missouri", true, "https://www.molottery.com"],
  ["MT", "Montana", true, "https://www.montanalottery.com"],
  ["NE", "Nebraska", true, "https://nelottery.com"],
  ["NV", "Nevada", false, null],
  ["NH", "New Hampshire", true, "https://nhlottery.com"],
  ["NJ", "New Jersey", true, "https://www.njlottery.com"],
  ["NM", "New Mexico", true, "https://www.nmlottery.com"],
  ["NY", "New York", true, "https://nylottery.ny.gov"],
  ["NC", "North Carolina", true, "https://nclottery.com"],
  ["ND", "North Dakota", true, "https://www.lottery.nd.gov"],
  ["OH", "Ohio", true, "https://www.ohiolottery.com"],
  ["OK", "Oklahoma", true, "https://www.lottery.ok.gov"],
  ["OR", "Oregon", true, "https://www.oregonlottery.org"],
  ["PA", "Pennsylvania", true, "https://www.palottery.state.pa.us"],
  ["RI", "Rhode Island", true, "https://www.rilot.com"],
  ["SC", "South Carolina", true, "https://www.sceducationlottery.com"],
  ["SD", "South Dakota", true, "https://lottery.sd.gov"],
  ["TN", "Tennessee", true, "https://www.tnlottery.com"],
  ["TX", "Texas", true, "https://www.txlottery.org"],
  ["UT", "Utah", false, null],
  ["VT", "Vermont", true, "https://vtlottery.com"],
  ["VA", "Virginia", true, "https://www.valottery.com"],
  ["WA", "Washington", true, "https://walottery.com"],
  ["WV", "West Virginia", true, "https://wvlottery.com"],
  ["WI", "Wisconsin", true, "https://wilottery.com"],
  ["WY", "Wyoming", true, "https://wyolotto.com"],
].map(([abbreviation, name, has_lottery, official_lottery_url]) => ({
  id: `state-${(abbreviation as string).toLowerCase()}`,
  abbreviation: abbreviation as string,
  name: name as string,
  slug: (name as string).toLowerCase().replace(/[^a-z0-9]+/g, "-"),
  has_lottery: has_lottery as boolean,
  official_lottery_url: official_lottery_url as string | null,
}));